import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useWorkspace } from '../lib/WorkspaceContext'
import './Sos.css'

export default function Sos({ usuario, onVolver }) {
  const { workspaceId } = useWorkspace()
  const [contenido, setContenido] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!workspaceId) return
    cargar()
  }, [workspaceId])

  const cargar = async () => {
    setLoading(true)
    const { data } = await supabase.from('rescate_contenido')
      .select('*').eq('workspace_id', workspaceId).eq('activo', true).order('orden')
    const items = data || []
    setContenido(items)
    setLoading(false)

    if (items.length > 0) {
      await supabase.from('rescate_accesos').insert(
        items.map(item => ({ usuario_id: usuario.id, contenido_id: item.id, workspace_id: workspaceId }))
      )
    }
  }

  return (
    <div className="sos-page">
      <div className="page-header">
        <button className="clases-back" onClick={onVolver}>← Volver</button>
        <h1 className="page-titulo">🆘 S.O.S.</h1>
        <p className="page-subtitulo">Un momento de flaqueza no define tu proceso</p>
      </div>

      <div className="sos-contenido">
        {loading ? (
          <p className="sos-vacio">Cargando...</p>
        ) : contenido.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🌿</div>
            <p>Todavía no hay contenido de S.O.S. cargado para tu espacio.</p>
          </div>
        ) : (
          contenido.map(item => (
            <div key={item.id} className="sos-card">
              {item.titulo && <p className="sos-card-titulo">{item.titulo}</p>}
              {item.tipo === 'frase' && <p className="sos-card-frase">"{item.texto}"</p>}
              {item.tipo === 'imagen' && <img src={item.media_url} alt={item.titulo || 'Inspiración'} className="sos-card-imagen" />}
              {item.tipo === 'audio' && <audio controls src={item.media_url} className="sos-card-audio" />}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
